/**
 * å¤æ­æ¯å¦æ°å­
 * @return {Boolean} æ¯å¦æ°å­
 */
import isType from './is-type';
var isNumber = function (value) {
    return isType(value, 'Number');
};
export default isNumber;
//# sourceMappingURL=is-number.js.map